import type { PriceData } from "@pandas/http-client";
import { StateCreator } from "zustand";
import { LocalStorage } from "../index";

export type DeviceType = "smartphone" | "tablet";

export interface DeviceInfo {
	deviceType: DeviceType;
	imei: string | null;
	brand: string | null;
	model: string | null;
	color: string | null;
	capacity: string | null;
	memory: string | null;
	selectedProduct: string | null;
}

// INITIAL STATE
export type DeviceInfoSlice = {
	deviceInfo: DeviceInfo;
	priceInfo: PriceData | null;
	setDeviceInfo: (deviceInfo: Partial<DeviceInfo>) => void;
	setPriceInfo: (priceInfo: PriceData) => void;
	resetPriceInfo: () => void;
};

const initialState = {
	deviceInfo: {
		deviceType: "smartphone" as DeviceType,
		imei: null,
		brand: null,
		model: null,
		color: null,
		capacity: null,
		memory: null,
		selectedProduct: null,
	},
	priceInfo: null,
};

export const createDeviceInfoSlice: StateCreator<
	LocalStorage,
	[],
	[
		[
			"zustand/persist",
			{
				deviceInfo: DeviceInfo;
				priceInfo: PriceData | null;
			},
		],
	],
	DeviceInfoSlice
> = (set) => ({
	...initialState,
	setDeviceInfo: (deviceInfo: Partial<DeviceInfo>) =>
		set((state) => {
			state.priceInfo = null;
			return { deviceInfo: { ...state.deviceInfo, ...deviceInfo } };
		}),
	setPriceInfo: (priceInfo: PriceData) => set(() => ({ priceInfo: priceInfo })),
	resetPriceInfo: () => set(() => ({ priceInfo: null })),
});
